import React, { createContext, useContext, useEffect, useReducer } from 'react';
import { loginApi, getAdminMeApi } from '../services/api';

const AuthContext = createContext(null);

const initialState = { isAuthenticated: false, isInitialised: false, user: null };

function reducer(state, action) {
  switch (action.type) {
    case 'INIT': return { ...state, isInitialised: true, ...action.payload };
    case 'LOGIN': return { ...state, isAuthenticated: true, user: action.payload };
    case 'LOGOUT': return { ...state, isAuthenticated: false, user: null };
    default: return state;
  }
}

export function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const login = async (email, password) => {
    const { data } = await loginApi(email, password);
    const { token, user } = data;
    localStorage.setItem('accessToken', token);
    localStorage.setItem('userId', user._id);
    dispatch({ type: 'LOGIN', payload: user });
  };

  const logout = () => {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userId');
    dispatch({ type: 'LOGOUT' });
  };

  useEffect(() => {
    (async () => {
      try {
        const token = localStorage.getItem('accessToken');
        if (token) {
          const { data } = await getAdminMeApi();
          dispatch({ type: 'INIT', payload: { isAuthenticated: true, user: data } });
        } else {
          dispatch({ type: 'INIT', payload: { isAuthenticated: false, user: null } });
        }
      } catch {
        dispatch({ type: 'INIT', payload: { isAuthenticated: false, user: null } });
      }
    })();
  }, []);

  return (
    <AuthContext.Provider value={{ ...state, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
